import { render } from "./Gastrology.vue?vue&type=template&id=5c5685b2&scoped=true"
import script from "./Gastrology.vue?vue&type=script&lang=ts"
export * from "./Gastrology.vue?vue&type=script&lang=ts"

import "./Gastrology.vue?vue&type=style&index=0&id=5c5685b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5c5685b2"

export default script